module.exports = __webpack_public_path__ + "images/sort-up-hover-blue-016c5b81.svg";